import { useTranslation } from 'react-i18next'
import type { LicenseCriteria } from '../../types'
import { createLicenseCriteriaFromForm } from '../../services/licensing'
import { buildCriteriaRequest, type CriteriaFormState } from './use-license-criteria-form'

export function useCriteriaSubmit(args: {
  form: CriteriaFormState
  onSuccess: ((criteria: LicenseCriteria) => void) | undefined
  onError: ((error: Error) => void) | undefined
}): (e: React.FormEvent) => Promise<void> {
  const { t } = useTranslation('admin')
  const { form, onSuccess, onError } = args
  return async (e: React.FormEvent): Promise<void> => {
    e.preventDefault()
    if (!form.canSubmit) {
      form.setError(t('licensing.errors.selectOrgOrInvoice'))
      return
    }
    form.setIsSubmitting(true)
    form.setError(null)
    form.setSuccess(null)
    try {
      const request = buildCriteriaRequest({
        formData: form.formData,
        selectedInvoiceId: form.selectedInvoiceId,
        selectedInvoice: form.selectedInvoice,
        selectedFeatures: form.selectedFeatures,
      })
      const criteria = await createLicenseCriteriaFromForm(request)
      form.setSuccess(criteria)
      onSuccess?.(criteria)
      form.resetForm()
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : t('licensing.errors.failedToCreateCriteria')
      form.setError(errorMessage)
      onError?.(err instanceof Error ? err : new Error(errorMessage))
    } finally {
      form.setIsSubmitting(false)
    }
  }
}
